import React from "react";
import { useOrg } from "../../../contexts/OrganizationContext";
import { userNoteService } from "../../../services/userNoteService";

function UserNotes({ programSiteId, summary = false }) {
  const { organization } = useOrg();
  const [notes, setNotes] = React.useState([]);

  const isSignedIn = !!window.UW211?.CURRENT_USER;
  const notesEnabled = organization.userFeatures?.notes || window.UW211?.ORGANIZATION?.userFeatures?.notes;
  const canFlag = notesEnabled && isSignedIn;

  React.useEffect(() => {
    if (!notesEnabled || !programSiteId) return;
    userNoteService.getForProgramSite(programSiteId).then((data) => setNotes(data || []));
  }, [programSiteId, notesEnabled]);

  const noteCount = notes.length;

  if (noteCount === 0) return null;

  if (summary) {
    const first = notes[0];
    return (
      <div className="user-notes-summary">
        {noteCount === 1 ? (
          <>
            <span className="small-label">
              <i className="ico ico-language" /> User Update:&nbsp;
            </span>
            <p className="note">"{first.note}" — {first.author_name || "User Community"}</p>
          </>
        ) : (
          <span className="small-label">
            <i className="ico ico-language" />{" "}
            <span><span className="notes-count">{noteCount}</span> User Notes</span>
          </span>
        )}
      </div>
    );
  }

  const orgAbbr = organization.abbr || window.UW211?.ORGANIZATION?.abbr || "211";

  function handleFlag(noteId) {
    if (!window.confirm("Flag this note for removal?")) return;
    userNoteService.flagForRemoval(noteId).then(() => {
      userNoteService.getForProgramSite(programSiteId).then((data) => setNotes(data || []));
    });
  }

  return (
    <div className="program-site-user-notes">
      <div className="content">
        <label className="label">{noteCount} User {noteCount === 1 ? "note" : "notes"}</label>
        <div className="content-disclaimer">
          These updates have been submitted by the general public. Please note that they have NOT been reviewed or verified by {orgAbbr}.
        </div>
        <ul className="program-site-user-note-items">
          {notes.map((note) => (
            <li key={note.id} className="program-site-user-note">
              <div className="flag-note-confirmation-region" />
              <div>
                <i className="ico ico-language" />
                <div className="note">"{note.note}"</div>
              </div>
              <div className="byline">
                by {note.author_name} on {note.created_at}
                {canFlag && (
                  <a
                    className="flag-note-link"
                    href="#"
                    style={{ marginLeft: "0.7em" }}
                    onClick={(e) => { e.preventDefault(); handleFlag(note.id); }}
                  >
                    Remove this note
                  </a>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default UserNotes;
